(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function parseNum(value, fallback) {
    var num = parseFloat(value);
    return isNaN(num) ? fallback : num;
  }

  function initForm(root) {
    var form = root.querySelector('form.ws__form');
    if (!form || form.getAttribute('data-ws-ready') === 'true') return;
    form.setAttribute('data-ws-ready', 'true');

    var panels = toArray(form.querySelectorAll('[data-ws-panel]'));
    var steps = toArray(root.querySelectorAll('[data-ws-step]'));
    var lines = toArray(root.querySelectorAll('[data-ws-line]'));
    var status = form.querySelector('[data-ws-status]');
    var current = 0;

    function setStatus(msg, isError) {
      if (!status) return;
      status.textContent = msg || '';
      status.hidden = !msg;
      status.classList.toggle('is-error', !!isError);
    }

    function showStep(index) {
      current = Math.max(0, Math.min(index, panels.length - 1));
      panels.forEach(function (panel, i) {
        var active = i === current;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === current);
        step.classList.toggle('is-done', i < current);
        step.setAttribute('aria-current', i === current ? 'step' : 'false');
      });
      lines.forEach(function (line, i) {
        line.classList.toggle('is-done', i < current);
      });
      setStatus('', false);
      var focusable = panels[current].querySelector('input, select, textarea, button');
      if (focusable) focusable.focus({ preventScroll: true });
    }

    function requiredFields(panel) {
      return toArray(panel.querySelectorAll('[data-ws-required]'));
    }

    function validatePanel(panel) {
      var fields = requiredFields(panel);
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        var value = (field.value || '').trim();
        if (!value) {
          setStatus('Please fill in all required fields to continue.', true);
          field.focus();
          return false;
        }
        if (field.type === 'email' && field.validity && !field.validity.valid) {
          setStatus('Please enter a valid email address.', true);
          field.focus();
          return false;
        }
      }
      return true;
    }

    form.addEventListener('click', function (event) {
      var nextBtn = event.target.closest('[data-ws-next]');
      var prevBtn = event.target.closest('[data-ws-prev]');
      if (nextBtn) {
        event.preventDefault();
        if (!validatePanel(panels[current])) return;
        showStep(current + 1);
      }
      if (prevBtn) {
        event.preventDefault();
        showStep(current - 1);
      }
    });

    form.addEventListener('submit', function (event) {
      if (!validatePanel(panels[current])) {
        event.preventDefault();
      }
    });

    showStep(0);
  }

  function createMarkerIcon(L, accent) {
    return L.divIcon({
      className: 'ws__leaflet-marker',
      html:
        '<span class="ws__leaflet-marker-dot" style="background:' +
        accent +
        ';box-shadow:0 0 0 6px ' +
        accent +
        '33"></span>',
      iconSize: [16, 16],
      iconAnchor: [8, 8],
    });
  }

  function initMap(root) {
    var panel = root.querySelector('[data-ws-map-panel]');
    if (!panel || panel.getAttribute('data-ws-map-ready') === 'true') return;

    var canvas = panel.querySelector('[data-ws-map]');
    if (!canvas) return;

    var accent =
      getComputedStyle(root).getPropertyValue('--ws-accent').trim() || '#cf1f25';
    var lat = parseNum(panel.getAttribute('data-ws-map-lat'), 45);
    var lng = parseNum(panel.getAttribute('data-ws-map-lng'), -96);
    var zoom = parseNum(panel.getAttribute('data-ws-map-zoom'), 4);
    var caLat = parseNum(panel.getAttribute('data-ws-marker-ca-lat'), 43.6532);
    var caLng = parseNum(panel.getAttribute('data-ws-marker-ca-lng'), -79.3832);
    var usLat = parseNum(panel.getAttribute('data-ws-marker-us-lat'), 41.8781);
    var usLng = parseNum(panel.getAttribute('data-ws-marker-us-lng'), -87.6298);

    var mapInstance = null;
    var resizeTimer = null;

    function invalidateSize() {
      if (!mapInstance) return;
      mapInstance.invalidateSize({ animate: false });
    }

    function mountMap() {
      if (!window.L || mapInstance) return;

      panel.setAttribute('data-ws-map-ready', 'true');
      mapInstance = window.L.map(canvas, {
        zoomControl: true,
        scrollWheelZoom: false,
      }).setView([lat, lng], zoom);

      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(mapInstance);

      var markerIcon = createMarkerIcon(window.L, accent);
      window.L.marker([caLat, caLng], { icon: markerIcon })
        .addTo(mapInstance)
        .bindPopup('Canada');
      window.L.marker([usLat, usLng], { icon: markerIcon })
        .addTo(mapInstance)
        .bindPopup('United States');

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(invalidateSize, 120);
      });

      setTimeout(invalidateSize, 80);
      setTimeout(invalidateSize, 350);
    }

    function waitForLeaflet(attempts) {
      if (window.L) {
        mountMap();
        return;
      }
      if (attempts <= 0) return;
      setTimeout(function () {
        waitForLeaflet(attempts - 1);
      }, 80);
    }

    waitForLeaflet(40);
  }

  function boot() {
    toArray(document.querySelectorAll('[data-ws]')).forEach(function (root) {
      initForm(root);
      initMap(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-ws]')).forEach(function (el) {
      var form = el.querySelector('form.ws__form');
      if (form) form.removeAttribute('data-ws-ready');

      var panel = el.querySelector('[data-ws-map-panel]');
      if (panel) panel.removeAttribute('data-ws-map-ready');

      initForm(el);
      initMap(el);
    });
  });
})();
